export var EventPriority;
(function (EventPriority) {
    EventPriority["PROPANE"] = "0000_PROPANE";
    EventPriority["HIGH"] = "0001_HIGH";
    EventPriority["NORMAL"] = "0002_NORMAL";
    EventPriority["LOW"] = "0003_LOW";
    EventPriority["PTO"] = "0004_PTO";
})(EventPriority || (EventPriority = {}));
